<div class="z-header">
	<zui-hos-navigation [activeAccount]="account" [pxLogin]="isPxLogin"></zui-hos-navigation>
	<dispatcher-list *ngIf="showDLComponent$ | async"></dispatcher-list>
	<location-list *ngIf="!(showDLComponent$ | async) && (showLocationFilter$ | async)"></location-list>
</div>
